"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("quill/dist/quill.snow.css");
var Quill = require("quill");
//@ts-ignore
require("../theme.ts");
var style = document.createElement('style');
style.textContent = css;
document.querySelector('head').appendChild(style);
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Editor.prototype.installed = function () {
        var _this = this;
        var fonts = ['sofia', 'slabo', 'roboto', 'inconsolata', 'ubuntu'];
        var ele = this.shadowRoot.querySelector('#editor');
        document.body.appendChild(ele);
        var editor = new Quill('#editor', {
            bounds: '#editor',
            modules: {
                //syntax': true, //require highlight.js
                'toolbar': [
                    [{ 'font': fonts }, { 'size': [] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                    ['direction', { 'align': [] }],
                    ['link', 'image', 'video'],
                    ['clean']
                ],
            },
            placeholder: '',
            readOnly: false,
            theme: 'snow'
        });
        editor.on('text-change', function (delta, oldDelta, source) {
            // if (source == 'api') {
            //   console.log("An API call triggered this change.");
            // } else if (source == 'user') {
            //   console.log("A user action triggered this change.");
            // }
            _this.fire('text-change', {
                content: editor.getContents(),
                source: source
            });
        });
        var ctn = document.createElement('div');
        var placeholder = this.shadowRoot.querySelector('.placeholder');
        var rect = placeholder.getBoundingClientRect();
        var toolbar = document.querySelector('.ql-toolbar');
        ctn.appendChild(toolbar);
        ctn.appendChild(ele);
        //@ts-ignore
        ctn.style.position = 'absolute';
        document.body.appendChild(ctn);
        //@ts-ignore
        ctn.style.left = rect.left + 'px';
        //@ts-ignore
        ctn.style.top = rect.top + 'px';
        //console.log(rect)
        //more api https://quilljs.com/docs/api/
        this.editor = editor;
    };
    Editor.prototype.render = function (props) {
        return (omi_1.h("div", { class: 'placeholder' },
            omi_1.h("div", { id: "editor" }, props.children.length > 0 ? props.children : (this.innerHTML ? this.innerHTML : ''))));
    };
    Editor.css = css;
    Editor.propTypes = {};
    Editor = __decorate([
        omi_1.tag('m-editor')
    ], Editor);
    return Editor;
}(omi_1.WeElement));
exports.default = Editor;
